import DatePicker_DatePickerTextBetweenNavSkinComponent from '@wix/thunderbolt-elements/src/components/DatePicker/viewer/skinComps/DatePickerTextBetweenNavSkin/DatePickerTextBetweenNavSkin.skin';
import DatePicker_DatePickerTextBetweenNavSkinController from '@wix/thunderbolt-elements/src/components/DatePicker/viewer/DatePicker.controller';


const DatePicker_DatePickerTextBetweenNavSkin = {
  component: DatePicker_DatePickerTextBetweenNavSkinComponent,
  controller: DatePicker_DatePickerTextBetweenNavSkinController
};


export const components = {
  ['DatePicker_DatePickerTextBetweenNavSkin']: DatePicker_DatePickerTextBetweenNavSkin
};

